import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('assetsGrid');

    return {
        ASSET_TYPE: t('assetType'),
        LAST_ACTIVITY: t('lastActivity'),
        LAST_EDITED: t('lastEdited'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_ASSETS: t('noAssets'),
        NO_MORE_ASSETS: t('noMoreAssets')
    };
};

export default useTranslation;
